// An icon on its own carries no name. `title` shows one on hover and `aria-label` gives the
// same text to assistive technology, which the tooltip component this replaced did for neither.
export default function IconLink({ href, label, className = '', children }) {
  const attributes = href
    ? { href, target: '_blank', rel: 'noopener noreferrer' }
    : {};
  const Tag = href ? 'a' : 'span';

  return (
    <Tag className={`pb-1 ${className}`.trim()} title={label} aria-label={label} {...attributes}>
      {children}
    </Tag>
  );
}
